import ErrorPage from '../pages/ErrorPage/ErrorPage';
import routesDE from './routes';
import { reducersDE } from './reducers';

export const countryConfigDE = {
    errorPageComponent: ErrorPage,
    routes: routesDE,
    reducers: reducersDE
};
